import { Injectable, inject } from '@angular/core';
import { GegEvaluationScreenService } from './geg-evaluation-screen.service';
import { Router } from '@angular/router';
import { RoutePaths, RouterLinks } from '@nx-customer-apps/shared/enums';
import { ProjectStore } from '../../state/project/project.store';
import { take, tap } from 'rxjs';

@Injectable()
export class GegAlternativeSystemService extends GegEvaluationScreenService {
    private router = inject(Router);
    private projectStore = inject(ProjectStore);

    public navigateBack(): void {
        this.projectStore.project$
            .pipe(
                take(1),
                tap(project => {
                    this.router.navigate([RouterLinks.GEG, project!.id, RoutePaths.EvaluatedSystem]);
                })
            )
            .subscribe();
    }
}
